import { Announcement, AnnouncementType } from '@cartwheel/components'
import clsx from 'clsx'

type AnnouncementListProps = {
  title: string
  reasons: string[]
  type?: AnnouncementType
}

export default function AnnouncementList({
  title,
  reasons,
  type = AnnouncementType.Warning,
}: AnnouncementListProps) {
  const hasMultipleReasons = reasons.length > 1
  const listClasses = clsx(
    hasMultipleReasons ? 'list-disc pl-4' : 'list-none pl-0',
    'text-taupe-dark-50 space-y-1'
  )

  return (
    <Announcement
      type={type}
      title={title}
      message={
        <ul className={listClasses}>
          {reasons.map((reason) => (
            <li key={reason}>{reason}</li>
          ))}
        </ul>
      }
    />
  )
}
